import type { ProductPricesByLevel } from "./ProductPricesByLevel.js";
import { ProductSize } from "./ProductSize.js";

export const productSizeKeyMap = {
	[ProductSize.Xs]: "xs",
	[ProductSize.S]: "s",
	[ProductSize.M]: "m",
	[ProductSize.L]: "l",
} satisfies Record<ProductSize, Required<keyof ProductPricesByLevel>>;
